import React, { useState } from 'react';
import './css/contactform.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({ nombre: '', apellidos: '', email: '', solicitud: '' });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.nombre.trim()) newErrors.nombre = 'Este campo es obligatorio';
    if (!formData.apellidos.trim()) newErrors.apellidos = 'Este campo es obligatorio';
    if (!formData.email.trim()) newErrors.email = 'Este campo es obligatorio';
    else {
      const emailRegex = /\S+@\S+\.\S+/;
      if (!emailRegex.test(formData.email)) newErrors.email = 'Introduce un email válido';
    }
    return newErrors;
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
    } else {
      alert(`Formulario enviado: ${JSON.stringify(formData, null, 2)}`);
      setFormData({ nombre: '', apellidos: '', email: '', solicitud: '' });
      setErrors({});
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit} noValidate>
      <div className="form-field">
        <label htmlFor="nombre">Nombre *</label>
        <input
          type="text"
          id="nombre"
          name="nombre"
          value={formData.nombre}
          onChange={handleChange}
          className={errors.nombre ? 'input-error' : ''}
        />
        {errors.nombre && <div className="error-msg">{errors.nombre}</div>}
      </div>

      <div className="form-field">
        <label htmlFor="apellidos">Apellidos *</label>
        <input
          type="text"
          id="apellidos"
          name="apellidos"
          value={formData.apellidos}
          onChange={handleChange}
          className={errors.apellidos ? 'input-error' : ''}
        />
        {errors.apellidos && <div className="error-msg">{errors.apellidos}</div>}
      </div>

      <div className="form-field">
        <label htmlFor="email">Correo electrónico *</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className={errors.email ? 'input-error' : ''}
        />
        {errors.email && <div className="error-msg">{errors.email}</div>}
      </div>

      <div className="form-field">
        <label htmlFor="solicitud">Solicitud de información</label>
        <textarea
          id="solicitud"
          name="solicitud"
          rows="4"
          value={formData.solicitud}
          onChange={handleChange}
        />
      </div>

      <button type="submit" className="submit-button">Enviar</button>
    </form>
  );
};

export default ContactForm;